import { initHeader } from './modules/header.js';
import { initSliders } from './modules/slider.js';
import { initBioToggle } from './modules/bio-toggle.js';

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initSliders();
  initBioToggle();
});
